import {
  TRegisterBusinessDataRequest,
  TRegisterPersonDataRequest,
} from 'modules/customer/context';
import {
  useCustomerService,
  usePersonService,
} from 'modules/customer/services';
import { TProducts } from 'modules/products/context';
import { useCallback, useEffect, useState } from 'react';
import { Spinner } from '../../../../../../app/components';
import { TApplicationData } from '../ApplicationContent/ApplicationContent';
import { BorrowerContent, ConditionContent } from './components';
import { useAppContext } from 'app/context/AppContextProvider';
import { ProductSideSheet } from 'modules/products/components/ProductSideSheet';

export interface IApplicationDetails {
  handleClose: () => void;
  isOpen: boolean;
  application: TApplicationData | undefined;
  productInfo: TProducts | undefined;
  handleUpdateQualificationStatus: (
    application: TApplicationData | null,
    identifier: string,
  ) => void;
}

const ApplicationDetailsSideSheet = ({
  handleClose,
  handleUpdateQualificationStatus,
  isOpen,
  application,
  productInfo,
}: IApplicationDetails) => {
  const { is_issuer_app } = useAppContext();
  const { getPerson } = usePersonService();
  const { getBusiness } = useCustomerService();
  const [borrowerPersonData, setBorrowerPersonData] =
    useState<TRegisterPersonDataRequest>();
  const [borrowerBusinessData, setBorrowerBusinessData] =
    useState<TRegisterBusinessDataRequest>();
  const [isLoading, setIsLoading] = useState(false);

  const onClose = () => {
    handleClose();
  };

  const fetchBorrowerDetails = useCallback(
    async (applicationData: Partial<TApplicationData> | undefined) => {
      setIsLoading(true);
      try {
        if (productInfo) {
          await handleGetBorrower(productInfo, applicationData);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [productInfo],
  );

  const handleGetBorrower = useCallback(
    async (product: TProducts, applicationData?: Partial<TApplicationData>) => {
      try {
        const borrowerId = applicationData?.borrower?.id || '';
        const originator =
          is_issuer_app && applicationData?.originator?.id
            ? applicationData.originator.id
            : undefined;

        if (product.borrower_type === 'PERSON') {
          const personData = await getPerson(
            borrowerId || '',
            false,
            originator,
          );
          if (!personData) {
            handleClose();
          }

          setBorrowerPersonData(
            personData || ({} as TRegisterPersonDataRequest),
          );
        }
        if (product.borrower_type === 'BUSINESS') {
          const personData = await getBusiness(
            borrowerId || '',
            false,
            originator,
          );
          if (!personData) {
            handleClose();
          }
          setBorrowerBusinessData(
            personData || ({} as TRegisterBusinessDataRequest),
          );
        }
      } catch (error) {
        handleClose();
      }
    },
    [productInfo, is_issuer_app, application],
  );

  useEffect(() => {
    if (application) {
      fetchBorrowerDetails(application);
    }
  }, [application]);

  return (
    <ProductSideSheet open={isOpen} handleClose={onClose} title={'Solicitação'}>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <ConditionContent
            applicationData={application ?? null}
            handleUpdateQualificationStatus={handleUpdateQualificationStatus}
          />
          <BorrowerContent
            borrowerPerson={borrowerPersonData}
            borrowerBusiness={borrowerBusinessData}
            product={productInfo}
            applicationData={application}
          />
        </>
      )}
    </ProductSideSheet>
  );
};

export default ApplicationDetailsSideSheet;
